import { s as script, a as script$1 } from './Pagination-FX3EMQVP.js';
import { a as registerComponent } from './plugins-C7548x21.js';
import './config-nHWiBviw.js';
import 'vue';
import './Icon-fJqkx1gN.js';
import './helpers-O9h6_ICO.js';
import './typeof-Z4rCTFCZ.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script);
    registerComponent(Vue, script$1);
  }
};

export { script as BPagination, script$1 as BPaginationButton, Plugin as default };
